import React from 'react'
import PropTypes from 'prop-types'

const Column = (props) => {
    const { layer = 'md', size = 12, className = '' } = props
    const _className = 'col-' + layer + '-' + size + ' ' + className
    return (
        <div className={_className}>
            {props.children}
        </div>
    )
}

Column.propTypes = {
    layer: PropTypes.string,
    size: PropTypes.number,
    className: PropTypes.string,
}

export default Column



// WEBPACK FOOTER //
// ./src/modules/bootstrap/component/Column.js